import { Localization } from "constant";

import FacebookIcon from "constant/svgIcons/facebookIcon";
import InstagramIcon from "constant/svgIcons/instagramIcon";
import TiktokIcon from "constant/svgIcons/TiktokIcon";
import TwitterIcon from "constant/svgIcons/twitterIcon";

export const loanApplicationInitialValues = {
	disableEditForm: false,
	applicationStatus: "Pending Submission",
	loanApplicationId: "",
	customerNumber: "",
	cdeScrore: "",
	createdDate: "",
	createdBy: "",
	customerId: "",
	source: "",
	branch: "",
	branchName: "",
	typeOfApplication: [],
	salesAgent: "",
	salesAgentName: "",
	portfolio: "",
	portfolioName: "",
	productMake: "",
	productModel: "",
	productCondition: "",
	productColor: "",
	productCategory: "",
	interestLevel: "",
	interestLevelName: "",
	customerSource: "",
	customerStatus: "",
	interestRemark: "",
	suffixId: "",
	firstName: "",
	middleName: "",
	lastName: "",
	alias: "",
	mobileNum: "",
	altMobileNum: "",
	contactValidated: false,
	altcontactValidated: false,
	loanStatus: false,
	civilStatus: null,
	numberOfDependents: "",
	spouseProof: {},
	firstComakerProof: {},
	secondComakerProof: {},
	comakerPresentAddress: {},
	comakerProvincialAddress: {},
	comaker2PresentAddress: {},
	comaker2ProvincialAddress: {},
	dependents: [
		{
			name: "",
			age: "",
			occupation: "",
			address: "",
		},
	],
	existingApplications: [
		{
			loanApplicationId: "",
			loanApplicationStatus: "",
		},
	],
	updatedBy: "",
	updatedDate: "",
	emailAddress: "",
	socialMediaUr: "",
	socialMedia: [
		{
			id: null,
			link: "",
		},
	],
	consentToShareData: false,
	homePhoneNumber: "",
	gender: "",
	dateOfBirth: "",
	age: 0,
	loanSchedulingDate: "",
	height: 0,
	weight: 0,
	nationality: "",
	IDType: "",
	IDNumber: "",
	businessStyle: "",
	currentAddress: {
		streetName: "",
		houseNumber: "",
		province: "",
		city: "",
		barangay: "",
		zipCode: "",
		ownership: null,
	},
	provincialAddress: {
		streetName: "",
		houseNumber: "",
		province: "",
		city: "",
		barangay: "",
		zipCode: "",
	},
	previousAddress: {},
	residence: {
		residentType: "",
		ownership: "",
		nameOfLandlord: "",
		monthlyPayment: 0,
		lengthOfStayYears: "",
		lengthOfStayMonths: "",
		//will have extra fields depending on ownership
	},
	propertiesOwned: {
		residential: {
			have: false,
			landSize: "",
			currentAddress: "",
		},
		commercial: {
			have: false,
			landSize: "",
			currentAddress: "",
		},
		agricultural: {
			have: false,
			landSize: "",
			currentAddress: "",
		},
	},
	parents: {
		fatherName: "",
		fatherOccupation: "",
		motherName: "",
		motherOccupation: "",
	},
	employment: {
		selfEmployed: {
			have: false,
			nameOfBusiness: "",
		},
		employmentRecord: {
			have: false,
		},
	},
	spouse: {
		suffix: "",
		firstName: "",
		middleName: "",
		lastName: "",
		alias: "",
		gender: "",
		dateOfBirth: "",
		placeOfBirth: "",
		driverLicenseNum: "",
		telephoneNum: "",
		mobileNum: "",
		email: "",
		socialMedia: [
			{
				id: null,
				link: "",
			},
		],
		contactValidated: false,
		sourceOfIncome: {
			employed: {
				have: false,
				typeOfEmployment: "",
				employmentStatus: "",
				employerName: "",
				employerAddress: "",
				employerContactNumber: "",
				lengthOfServiceYears: "",
				lengthOfServiceMonths: "",
				department: "",
				position: "",
			},
			selfEmployed: {
				have: false,
				typeOfBusiness: "",
		        specifyBusiness: "",
				lengthOfPractiseYears: "",
				lengthOfPractiseMonths: "",
				businessAddress: "",
			},
			businessOwner: {
				have: false,
				typeOfBusiness: "",
				nameOfBusiness: "",
				businessAddress: "",
				lengthOfBusinessYears: "",
				lengthOfBusinessMonths: "",
			},
			pension: {
				have: false,
				list: [],
			},
			remittanceAllowance: {
				have: false,
				typeOfRemittance: "",
				nameOfSender: "",
				relationshipToSender: "",
				contactNumber: "",
				address: "",
			},
		},
		// employment: {
		//   selfEmployed: {
		//     have: false,
		//     nameOfBusiness: "",
		//   },
		//   employmentRecord: {
		//     have: false,
		//   },
		// },
		fatherName: "",
		fatherOccupation: "",
		motherName: "",
		motherOccupation: "",
	},
	cosignatoryRelationshipToApplicant: "",
	cosignatory: {
		civilStatus: "",
		numberOfDependents: "",
		suffix: "",
		firstName: "",
		middleName: "",
		lastName: "",
		alias: "",
		gender: "",
		dateOfBirth: "",
		placeOfBirth: "",
		driverLicenseNum: "",
		telephoneNum: "",
		mobileNum: "",
		email: "",
		socialMedia: [
			{
				id: null,
				link: "",
			},
		],
		contactValidated: false,
		employment: {
			selfEmployed: {
				have: false,
				nameOfBusiness: "",
			},
			employmentRecord: {
				have: false,
			},
		},
		dependents: [
			{
				name: "",
				age: "",
				occupation: "",
				address: "",
			},
		],
		fatherName: "",
		fatherOccupation: "",
		motherName: "",
		motherOccupation: "",
		// dependentName: "",
		// dependentAge: "",
		// dependentOccupation: "",
		// dependentAddress: "",
		firstSourceOfIncome: {
			employed: {
				have: false,
				typeOfEmployment: "",
				employmentStatus: "",
				employerName: "",
				employerAddress: "",
				employerContactNumber: "",
				lengthOfServiceYears: "",
				lengthOfServiceMonths: "",
				department: "",
				position: "",
			},
			selfEmployed: {
				have: false,
				typeOfBusiness: "",
		        specifyBusiness: "",
				lengthOfPractiseYears: "",
				lengthOfPractiseMonths: "",
				businessAddress: "",
			},
			businessOwner: {
				have: false,
				typeOfBusiness: "",
				nameOfBusiness: "",
				businessAddress: "",
				lengthOfBusinessYears: "",
				lengthOfBusinessMonths: "",
			},
			pension: {
				have: false,
				list: [],
			},
			remittanceAllowance: {
				have: false,
				typeOfRemittance: "",
				nameOfSender: "",
				relationshipToSender: "",
				contactNumber: "",
				address: "",
			},
		},
	},
	secondComakerRelationshipToApplicant: "",
	secondComakerBasicMonthlySalary: "",
	secondComakerTotalExpenses: "",
	secondComaker: {
		firstName: "",
		middleName: "",
		lastName: "",
		gender: "",
		dateOfBirth: "",
		mobileNum: "",
	},
	comaker: {
		civilStatus: "",
		numberOfDependents: "",
		suffix: "",
		firstName: "",
		middleName: "",
		lastName: "",
		alias: "",
		gender: "",
		dateOfBirth: "",
		placeOfBirth: "",
		driverLicenseNum: "",
		telephoneNum: "",
		mobileNum: "",
		email: "",
		socialMedia: [
			{
				id: null,
				link: "",
			},
		],
		contactValidated: false,
		employment: {
			selfEmployed: {
				have: false,
				nameOfBusiness: "",
			},
			employmentRecord: {
				have: false,
			},
		},
		dependents: [
			{
				name: "",
				age: "",
				occupation: "",
				address: "",
			},
		],
		fatherName: "",
		fatherOccupation: "",
		motherName: "",
		motherOccupation: "",
		// dependentName: "",
		// dependentAge: "",
		// dependentOccupation: "",
		// dependentAddress: "",
		firstSourceOfIncome: {
			employed: {
				have: false,
				typeOfEmployment: "",
				employmentStatus: "",
				employerName: "",
				employerAddress: "",
				employerContactNumber: "",
				lengthOfServiceYears: "",
				lengthOfServiceMonths: "",
				department: "",
				position: "",
			},
			selfEmployed: {
				have: false,
				typeOfBusiness: "",
		        specifyBusiness: "",
				lengthOfPractiseYears: "",
				lengthOfPractiseMonths: "",
				businessAddress: "",
			},
			businessOwner: {
				have: false,
				typeOfBusiness: "",
				nameOfBusiness: "",
				businessAddress: "",
				lengthOfBusinessYears: "",
				lengthOfBusinessMonths: "",
			},
			pension: {
				have: false,
				list: [],
			},
			remittanceAllowance: {
				have: false,
				typeOfRemittance: "",
				nameOfSender: "",
				relationshipToSender: "",
				contactNumber: "",
				address: "",
			},
		},
	},
	comakerBasicMonthlySalary: "",
	comakerTotalExpenses: "",
	income: {
		basicMonthlySalary: null,
		spouseBasicMonthlySalary: null,
		/* TODO : remove "income.comakerBasicMonthlySalary" below after "comakerBasicMonthlySalary" is success  */
		comakerBasicMonthlySalary: null,
		otherCompensation: null,
		spouseOtherCompensation: null,
		grossMonthlyIncome: null,
		spouseGrossMonthlyIncome: null,
		comakerGrossMonthlyIncome: null,
	},
	expenses: {
		rental: "",
		mortgageAmortization: "",
		foodOrClothing: "",
		transportation: "",
		waterElectricity: "",
		education: "",
		existingLoan: "",
		otherExpense: "",
	},
	totalIncome: "0",
	totalExpenses: "0",
	netDisposableIncome: "0",
	product: {
		porfolio: "",
		condition: "New",
		make: "",
		model: "",
		colour: "",
		price: 0,
		pricePreOwned: 0,
		prevAccountNumber: "",
		prevAccountName: "",
	},
	repaymentPlan: {
		downPayment: "",
		downPaymentPreOwned: "",
		tenure: "",
		tenurePreOwned: "",
		// totalCost: 0, // is now removed
		interestRate: 0,
		interestRatePreOwned: 0,
		totalLoanAmount: 0,
		totalLoanAmountPreOwned: 0,
		emi: 0, //monthly amortization
		emiPreOwned: 0, //monthly amortization
	},
	processingDetails: {
		engineNum: "",
		chassisNum: "",
	},
	loanInformationCorrect: false,
	makerIDProof: {
		UMID: {
			have: true,
			number: "",
			front: {},
			back: {},
		},
		driverLicense: {
			have: false,
		},
		passport: {
			have: false,
		},
		nationalID: {
			have: false,
		},
		votersID: {
			have: false,
		},
		SSSID: {
			have: false,
		},
		GSISID: {
			have: false,
		},
	},
	sourceOfIncome: {
		employed: {
			have: false,
			typeOfEmployment: "",
			employmentStatus: "",
			employeeName: "",
			employeeAddress: "",
			employeeContactNumber: "",
			lengthOfServiceYears: "",
			lengthOfServiceMonths: "",
			department: "",
			position: "",
		},
		selfEmployed: {
			have: false,
			typeOfBusiness: "",
			specifyBusiness: "",
			lengthOfPractiseYears: "",
			lengthOfPractiseMonths: "",
			businessAddress: "",
		},
		businessOwner: {
			have: false,
			typeOfBusiness: "",
			nameOfBusiness: "",
			businessAddress: "",
			lengthOfBusinessYears: "",
			lengthOfBusinessMonths: "",
		},
		pension: {
			have: false,
			list: [],
		},
		remittanceAllowance: {
			have: false,
			typeOfRemittance: "",
			nameOfSender: "",
			relationshipToSender: "",
			contactNumber: "",
			address: "",
		},
	},
	comakerIDProof: {
		UMID: {
			have: true,
			number: "",
			front: {},
			back: {},
		},
		driverLicense: {
			have: false,
		},
		passport: {
			have: false,
		},
		nationalID: {
			have: false,
		},
		votersID: {
			have: false,
		},
		SSSID: {
			have: false,
		},
		GSISID: {
			have: false,
		},
	},
	residentialProof: [],
	incomeProof: [],
	comakerIncomeProof: [],
	reference1: {
		relationshipWithApplicant: "",
		specifyRelationship: "",
	},
	reference2: {
		relationshipWithApplicant: "",
		specifyRelationship: "",
	},
	reference3: {
		relationshipWithApplicant: "",
		specifyRelationship: "",
	},
	referenceVerified: false,
	CSR: "",
	residentialPayments: "",
	utilitiesPayments: "",
	materials: "",
	painted: "",
	numberOfBedrooms: "",
	estimatedValue: "",
	furnitureAppliances: [],
	neighborhoodType: "",
	livingCondition: [],
	residenceAccessibleBy: [],
	residentialLocationImages: {
		image1: {},
		image2: {},
		image3: {},
	},
	investigationRemarks: "",
	salesInvestigatorName: "",
	loanReviewerName: "",
};

const STEP_LABELS_NEW_NEMAR = [
	"Basic Information",
	"Additional Information",
	"Spouse/Dependents Information",
	"Co-Signatory and/or Co-Maker Information",
	"Income",
	"Loan",
	"Supporting Documents",
	"References",
];

const STEP_LABELS_WHEELTEK = [
	"Basic Information",
	"Additional Information",
	"Spouse/Dependents Information",
	"Comaker Information",
	"Income",
	"Loan",
	"Loan Scheduler",
	"Supporting Documents",
	"References",
];

const STEP_LABELS_MOTORACE = [
	"Basic Information",
	"Additional Information",
	"Comaker & Dependents Information",
	"Income",
	"Loan",
	"Loan Scheduler",
	"Supporting Documents",
	"References",
	"Investigation",
];

const STEP_LABELS_CELESTINA = [
	"Basic Information",
	"Additional Information",
	"Comaker Information",
	"Income",
	"Loan",
	"Loan Scheduler",
	"Supporting Documents",
	"References",
	"Investigation",
];

export const stepLabels = Localization.isUsingNewNemarConfig
	? STEP_LABELS_NEW_NEMAR
	: Localization.isUsingWheeltekConfig
	? STEP_LABELS_WHEELTEK
	: Localization.isUsingCelestinaConfig
	? STEP_LABELS_CELESTINA
	: Localization.isUsingMotoraceConfig
	? STEP_LABELS_MOTORACE
	: STEP_LABELS_MOTORACE;

const ColoredCircle = ({ color }) => (
	<div
		style={{
			backgroundColor: color,
			borderRadius: "50%",
			width: 20,
			height: 20,
		}}></div>
);

export const calculateAge = (dobString) => {
	const birthDate = new Date(dobString);
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const monthDifference = today.getMonth() - birthDate.getMonth();
	if (
		monthDifference < 0 ||
		(monthDifference === 0 && today.getDate() < birthDate.getDate())
	) {
		age--;
	}

	return age;
};

export const addressOwnershipOption = [
	{
		id: 1,
		name: `Owned`,
	},
	{
		id: 2,
		name: `Free Use`,
	},
	{
		id: 3,
		name: `Rented`,
	},
	{
		id: 4,
		name: `Mortgage`,
	},
	{
		id: 5,
		name: `Parental Property`,
	},
	{
		id: 6,
		name: `Company provided`,
	},
];

export const interestLevelOptions = [
	{
		id: 1,
		name: `Hot`,
		icon: <ColoredCircle color={"red"} />,
	},
	{
		id: 2,
		name: `Warm`,
		icon: <ColoredCircle color={"orange"} />,
	},
	{
		id: 3,
		name: `Cold`,
		icon: <ColoredCircle color={"blue"} />,
	},
	/* TFC-496 Wheeltek */
	...(Localization.isUsingMotoraceConfig
		? [
				{
					id: 4,
					name: `Blacklist`,
					icon: <ColoredCircle color={"black"} />,
				},
		  ]
		: []),
];

export const socialMediaOptions = [
	{
		id: 1,
		name: `Facebook`,
		icon: <FacebookIcon color={"red"} />,
	},
	{
		id: 2,
		name: `Instagram`,
		icon: <InstagramIcon color={"orange"} />,
	},
	{
		id: 3,
		name: `Twitter`,
		icon: <TwitterIcon color={"blue"} />,
	},
	{
		id: 4,
		name: `TikTok`,
		icon: <TiktokIcon />,
	},
];

export const IdTypeOption = [
	{
		id: 1,
		name: "National ID",
	},
	{
		id: 2,
		name: "Passport",
	},
	{
		id: 3,
		name: "Unified Multi-Purpose (UMID) ID",
	},
	{
		id: 4,
		name: "Voters ID",
	},
	{
		id: 5,
		name: "Social Security (SSS) ID",
	},
	{
		id: 6,
		name: "Government Service Insurance System (GSIS) ID",
	},
	{
		id: 7,
		name: "BIR",
	},
	{
		id: 8,
		name: "PHilhealth",
	},
	{
		id: 9,
		name: "PagiBIG",
	},
	{
		id: 10,
		name: "Cedula",
	},
	{
		id: 11,
		name: "Brgy Clearance",
	},
	{
		id: 12,
		name: "Driver’s License",
	},
];

export const WheeltekIdTypeOption = [
	{
		id: 1,
		name: "Driver’s License",
	},
	{
		id: 2,
		name: "GSIS",
	},
	{
		id: 3,
		name: "National ID",
	},
	{
		id: 4,
		name: "PAG-IBIG",
	},
	{
		id: 5,
		name: "Philhealth",
	},
	{
		id: 6,
		name: "Philippine Passport",
	},
	{
		id: 7,
		name: "Postal ID",
	},
	{
		id: 8,
		name: "PRC",
	},
	{
		id: 9,
		name: "TIN",
	},
	{
		id: 10,
		name: "UMID Card",
	},
	{
		id: 11,
		name: "Voters ID or Certification with E-Signature",
	},
	{
		id: 12,
		name: "Firearms License",
	},
	{
		id: 13,
		name: "PWD",
	},
	{
		id: 14,
		name: "Senior Citizen ID",
	},
	{
		id: 15,
		name: "Social Security System (SSS) ID",
	},
];

export const mobileNoOwnerOption = [
	{
		id: 1,
		name: "Applicant",
	},
	{
		id: 2,
		name: "Sibling",
	},
	{
		id: 3,
		name: "Spouse",
	},
	{
		id: 4,
		name: "Parents",
	},
	{
		id: 5,
		name: "Relative",
	},
];

export const typeOfEmployment = [
	{
		id: 1,
		name: "Private",
	},
	{
		id: 2,
		name: "Government",
	},
];

export const employmentStatusOption = [
	{
		id: 1,
		name: "Regular",
	},
	{
		id: 2,
		name: "Probationary",
	},
	{
		id: 3,
		name: "Job Order",
	},
	{
		id: 4,
		name: "Contractual",
	},
];

export const businessTypeOption = [
	{
		id: 1,
		name: "Baker",
	},
	{
		id: 2,
		name: "Barber",
	},
	{
		id: 3,
		name: "Barista",
	},
	{
		id: 4,
		name: "Barker",
	},
	{
		id: 5,
		name: "Bus Driver",
	},
	{
		id: 6,
		name: "Butcher",
	},
	{
		id: 7,
		name: "Buy and sell",
	},
	{
		id: 8,
		name: "Caretaker",
	},
	{
		id: 9,
		name: "Carpenter",
	},
	{
		id: 10,
		name: "Construction Worker",
	},
	{
		id: 11,
		name: "Content Creator",
	},
	{
		id: 12,
		name: "Cook",
	},
	{
		id: 13,
		name: "Dealer",
	},
	{
		id: 14,
		name: "Electrician",
	},
	{
		id: 15,
		name: "Farm Owner",
	},
	{
		id: 16,
		name: "Farm Worker",
	},
	{
		id: 17,
		name: "Freelance",
	},
	{
		id: 18,
		name: "Jeep Driver",
	},
	{
		id: 19,
		name: "Maintenance/Contracto",
	},
	{
		id: 20,
		name: "Manicurist",
	},
	{
		id: 21,
		name: "Mechanic",
	},
	{
		id: 22,
		name: "Rider",
	},
	{
		id: 23,
		name: "Sewer",
	},
	{
		id: 24,
		name: "Taxi Driver",
	},

	{
		id: 25,
		name: "TC Driver",
	},
	{
		id: 26,
		name: "Technician",
	},
	{
		id: 27,
		name: "Truck Driver",
	},
	{
		id: 28,
		name: "Vendor",
	},
	{
		id: 29,
		name: "Welder",
	},
	{
		id: 30,
		name: "Others",
	},
];

export const businessOwnerOption = [
	{
		id: 1,
		name: "One-person Corporation",
	},
	{
		id: 2,
		name: "Corporation",
	},
	{
		id: 3,
		name: "Sole Proprietorship",
	},
	{
		id: 4,
		name: "Partnership",
	},
];

export const remittanceOption = [
	{
		id: 1,
		name: "Local",
	},
	{
		id: 2,
		name: "Overseas",
	},
];
export const suffixOptions = [
	{
		id: 1,
		name: `Jr.`,
	},
	{
		id: 2,
		name: `Sr.`,
	},
	{
		id: 3,
		name: `N.A`,
	},
];

export const CUSTOMER_TYPE = [
	{
		id: 1,
		name: "Regular",
	},
	{
		id: 2,
		name: "1st Valley Bank Employee",
	},
	{
		id: 3,
		name: "CPDC Employees",
	},
	{
		id: 4,
		name: "KVI Employees",
	},
	{
		id: 5,
		name: "Inquiry (Online)",
	},
];

export const MARRIAGE_STATUS_OPTION = [
	{
		id: 1,
		name: "Married",
	},
	{
		id: 2,
		name: "Separated",
	},
	{
		id: 3,
		name: "Single Parent (Father)",
	},
	{
		id: 4,
		name: "Single Parent (Mother)",
	},
];

const wheeltekPortfolioOptions = ["Two Wheeler", "Three Wheeler"];
const motoracePortfolioOptions = ["Two Wheeler"];
export const PORTFOLIO_OPTIONS =
	Localization.isUsingWheeltekConfig || Localization.isUsingNewNemarConfig
		? wheeltekPortfolioOptions
		: motoracePortfolioOptions;

export const makeOptions = [
	{
		id: 1,
		name: `Aprilia`,
	},
	{
		id: 2,
		name: `BMW`,
	},
	{
		id: 3,
		name: `Ducati`,
	},
	{
		id: 4,
		name: `Harley-Davidson`,
	},
	{
		id: 5,
		name: `Honda`,
	},
];

export const productCategoryOptions = [
	{
		id: 1,
		name: `Motorcycle`,
	},
	{
		id: 2,
		name: `Scooter`,
	},
	{
		id: 3,
		name: `E-Bike`,
	},
	{
		id: 4,
		name: `ATV`,
	},
];

export const productModelOptions = [
	{
		id: 1,
		name: `Big Ruckus PS250`,
	},
	{
		id: 2,
		name: `Elsinore CR250M`,
	},
	{
		id: 3,
		name: `Nighthawk CB250`,
	},
	{
		id: 4,
		name: `Super Sport CB175`,
	},
	{
		id: 5,
		name: `Phantom TA200`,
	},
	{
		id: 6,
		name: `XR150L`,
	},
];

export const productColourOptions = [
	{
		id: 1,
		name: `Black`,
	},
	{
		id: 2,
		name: `Red`,
	},
	{
		id: 3,
		name: `White`,
	},
];

export const TYPE_OF_APPLICATION = [
	{
		id: 1,
		name: `First Time`,
	},
	{
		id: 2,
		name: `Repeat Customer`,
	},
	{
		id: 3,
		name: `Repo History in WMC`,
	},
	{
		id: 4,
		name: `Active Accounts`,
	},
	{
		id: 5,
		name: `Fully Paid in Other Dealer`,
	},
	{
		id: 3,
		name: `Repo in Other Dealer`,
	},
	{
		id: 3,
		name: `Active Accounts From Dealer`,
	},
	{
		id: 3,
		name: `Others`,
	},
];
export const genderOptions = [
	{
		id: 1,
		name: `Male`,
	},
	{
		id: 2,
		name: `Female`,
	},
	{
		id: 3,
		name: `Prefer Not To Say`,
	},
];

export const RELATIONSHIP_TO_APPLICANT_OPTION_WHEELTEK = [
	{
		id: 1,
		name: "Associate",
	},
	{
		id: 2,
		name: "Business Partner",
	},
	{
		id: 3,
		name: "Company Executive",
	},
	{
		id: 4,
		name: "Co-Worker",
	},
	{
		id: 5,
		name: "In-law",
	},
	{
		id: 6,
		name: "Legal Guardian",
	},
	{
		id: 7,
		name: "Parent",
	},
	{
		id: 8,
		name: "Relative",
	},
	{
		id: 9,
		name: "Spouse",
	},
];

export const RELATIONSHIP_TO_APPLICANT_OPTION_WHEELTEK_RELATIVE_OPTIONS = [
	{
		id: 1,
		name: "Aunt",
	},
	{
		id: 2,
		name: "Cousin",
	},
	{
		id: 3,
		name: "Grandparent",
	},
	{
		id: 4,
		name: "In-law",
	},
	{
		id: 5,
		name: "Legal Guardian",
	},
	{
		id: 6,
		name: "Parent",
	},
	{
		id: 7,
		name: "Sibling",
	},
	{
		id: 8,
		name: "Spouse",
	},
	{
		id: 9,
		name: "Uncle",
	},
	{
		id: 10,
		name: "Others",
	},
];

export const RELATIONSHIP_TO_APPLICANT_OPTION_WHEELTEK_NON_RELATIVE_OPTIONS = [
	{
		id: 1,
		name: "Associate",
	},
	{
		id: 2,
		name: "Business Partner",
	},
	{
		id: 3,
		name: "Company Executive",
	},
	{
		id: 4,
		name: "Co-Worker",
	},
	{
		id: 5,
		name: "Friend",
	},
	{
		id: 6,
		name: "Neighbor",
	},
	{
		id: 7,
		name: "Others",
	},
];

export const IDTypeOptions = [
	{
		id: 1,
		name: `National ID`,
	},
	{
		id: 2,
		name: `Driver's License`,
	},
	{
		id: 3,
		name: `Passport`,
	},
	{
		id: 4,
		name: `UMID`,
	},
	{
		id: 5,
		name: `SSSID`,
	},
	{
		id: 6,
		name: `GSIS ID`,
	},
	{
		id: 7,
		name: `Voters ID`,
	},
];

export const residentTypeOptions = [
	{
		id: 1,
		name: `Apartment`,
	},
	{
		id: 2,
		name: `Bungalow`,
	},
	{
		id: 3,
		name: `Chalet`,
	},
	{
		id: 4,
		name: `Company House`,
	},
	{
		id: 5,
		name: `Government Housing Unit`,
	},
	{
		id: 6,
		name: `Mansion`,
	},
	{
		id: 7,
		name: `Semi-Mansion`,
	},
	{
		id: 8,
		name: `Shanty`,
	},
	{
		id: 9,
		name: `Others`,
	},
];

export const ownershipOptions = [
	{
		id: 1,
		name: `Owned`,
	},
	{
		id: 2,
		name: `Free Use`,
	},
	{
		id: 3,
		name: `Rented`,
	},
	{
		id: 4,
		name: `Mortgage`,
	},
	{
		id: 5,
		name: `Parental Property`,
	},
	{
		id: 6,
		name: `Company provided`,
	},
];

export const mortgagePaymentOptions = [
	{
		id: 1,
		name: `Prompt`,
	},
	{
		id: 2,
		name: `Delayed`,
	},
];

export const employmentStatusOptions = [
	{
		id: 1,
		name: `Contractual`,
	},
	{
		id: 2,
		name: `Probationary`,
	},
	{
		id: 3,
		name: `Casual`,
	},
	{
		id: 4,
		name: `Permanent`,
	},
];

export const residentialPaymentOptions = [
	{
		id: 1,
		name: `Prompt`,
	},
	{
		id: 2,
		name: `Delayed`,
	},
	{
		id: 3,
		name: `N.A`,
	},
];

export const materialOptions = [
	{
		id: 1,
		name: `Concrete`,
	},
	{
		id: 2,
		name: `Semi-Concrete`,
	},
	{
		id: 3,
		name: `Bamboo & Nipa`,
	},
];

export const paintedOptions = [
	{
		id: 1,
		name: `Painted`,
	},
	{
		id: 2,
		name: `Semi-Painted`,
	},
	{
		id: 3,
		name: `Unpainted`,
	},
];

export const neighborhoodTypeOptions = [
	{
		id: 1,
		name: `Residential`,
	},
	{
		id: 2,
		name: `Commercial`,
	},
	{
		id: 3,
		name: `Mixed`,
	},
	{
		id: 3,
		name: `Slum`,
	},
	{
		id: 3,
		name: `Provincial`,
	},
	{
		id: 3,
		name: `Class Sub`,
	},
	{
		id: 3,
		name: `Government Project`,
	},
];

export const TYPE_OF_INCOME = [
	{
		id: 1,
		name: "Private Employee",
	},
	{
		id: 2,
		name: "Government Employee",
	},
	{
		id: 3,
		name: "Pensionner",
	},
	{
		id: 4,
		name: "Remittance",
	},
	{
		id: 5,
		name: "Business (with permit)",
	},
	{
		id: 6,
		name: "PUV driver",
	},
	{
		id: 7,
		name: "TC driver",
	},
	{
		id: 8,
		name: "others",
	},
];

// loanApplicationInitialValues = {
// applicationStatus: "Draft"
//    createdDate: "2024-05-01",
//   createdBy: "ADMIN",
//   customerId: "65536",
//   source: "LOS - Chennai",
//   branch: "Chennai River",
//   salesAgent: "Kayn",
//   portfolio: 1,
//   interestLevel: 2,
//   customerSource: 1,
//   interestRemark: "Customer is very interested in this car",
//   suffix: 1,
//   firstName: "Cassandra",
//   middleName: "Melinda",
//   lastName: "Claire",
//   alias: "Cassie",
//   mobileNum: "+92123838412932",
//   contactValidated: true,
//   emailAddress: "cassandra@gmail.com",
//   socialMedia: [
//     {
//       id: 1,
//       link: "https://instagram.com/cassandra11122",
//     },
//   ],
//   consentToShareData: true,
//   homePhoneNumber: "11239923",
//   gender: 2,
//   dateOfBirth: "1970-09-05",
//   height: 150,
//   weight: 50,
//   nationality: "Phillipines",
//   IDType: 1,
//   IDNumber: "238230498120",
//   currentAddress: {
//     address: "Charming Evenue",
//     streetNumber: "A1232",
//     province: 1,
//     city: "Copper",
//     barangay: "Silver",
//     zipCode: "983423",
//   },
//   provincialAddress: {
//     address: "Charming Evenue",
//     streetNumber: "K01232",
//     province: 1,
//     city: "Copper",
//     barangay: "Silver",
//     zipCode: "983423",
//   },
//   previousAddress: {
//    have: true,
//     address: "Charming Evenue",
//     streetNumber: "K01232",
//     province: 1,
//     city: "Copper",
//     barangay: "Silver",
//     zipCode: "983423",
//    },
//   residence: {
//     residentType: 3,
//     ownership: 2,
//     nameOfLandlord: "Karina",
//     monthlyPayment: 70000,
//     lengthOfStay: "3 Years",
//     //will have extra fields depending on ownership
//   },
//   propertiesOwned: {
//     residential: {
//       have: true,
//       landSize: "200000",
//       currentAddress: "Sudo Address AAA"
//     },
//     commercial: {
//       have: false,
//       landSize: "",
//       currentAddress: ""
//     },
//     agricultural: {
//       have: false,
//       landSize: "",
//      currentAddress: ""
//     },
//   },
//   parents: {
//     fatherName: "John",
//     fatherOccupation: "Farmer",
//     motherName: "Mary",
//     motherOccupation: "Farmer",
//   },
//   employment: {
//     selfEmployed: {
//       have: true,
//       typeOfBusiness: "Farming",
//        lengthOfBusiness: "20 Years"
//     },
//     employmentRecord: {
//       have: true,
//     },
//   },
//   comaker: {
//     civilStatus: 2,
//     numberOfDependents: "1",
//     suffix: 2,
//     firstName: "Jenny",
//     middleName: "K",
//     lastName: "Linda",
//     alias: "JK",
//     gender: 2,
//     dateOfBirth: "1987-08-12",
//     placeOfBirth: "Phillipines",
//     driverLicenseNum: "23239928345",
//     telephoneNum: "",
//     mobileNum: "",
//     email: "",
//     socialMedia: [
//       {
//         id: null,
//         link: "",
//       },
//     ],
//     contactValidated: false,
//     employment: {
//       selfEmployed: {
//         have: false,
//       },
// employmentRecord: {
//   have: false,
//   status: "",
//   TIN: "",
//   employer: "",
//   officeAddress: "",
//   department: "",
//   position: "",
//   serviceLength: "",
//   officeNumber: ""
// },
//     },
//     dependents: [
//       {
//         name: "Calvin",
//         age: "12",
//         occupation: "Student",
//         address: "Charming Avenue",
//       },
//     ],
//     // dependentName: "",
//     // dependentAge: "",
//     // dependentOccupation: "",
//     // dependentAddress: "",
//   },
//   income: {
//     grossMonthlyIncome: "80000",
//     comakerGrossMonthlyIncome: "",
//     basicMonthlySalary: "",
//     otherCompensation: "",
//     comakerBasicMonthlySalary: "",
//     spouseOtherCompensation: "",
//   },
//   expenses: {
//     rental: "20000",
//     mortgageAmortization: "",
//     foodOrClothing: "",
//     transportation: "",
//     waterElectricity: "",
//     education: "",
//     existingLoan: "",
//     otherExpense: "",
//   },
//   totalIncome: "80000",
//   totalExpenses: "20000",
//   netDisposableIncome: "60000",
//   product: {
//     porfolio: 1,
//     category: "",
//     condition: "New",
//     make: "",
//     model: "",
//     colour: "",
//     price: 0,
//   },
//   repaymentPlan: {
//     downPayment: "",
//     tenure: "",
//     totalCost: 12000, //GIVE RAW number, later will be processed in front
//     interestRate: 40,
//     totalLoanAmount: 23000,
//     emi: 0,
//   },
//   processingDetails: {
//     engineNum: "AS92134812",
//     chassisNum: "WNJ123988",
//   },
//   loanInformationCorrect: true,
//   makerIDProof: {
//     UMID: {
//       have: true,
//       number: "",
//       front: {
//   filename: "FRONT-UMID",
//   filetype: "JPG",
//   type: 'supporting-docs',
//   url: "https://www.w3schools.com/images/w3schools_green.jpg",
// },
//       back: {},
//     },
//     driverLicense: {
//       have: false,
//     },
//     passport: {
//       have: false,
//     },
//     nationalID: {
//       have: false,
//     },
//     votersID: {
//       have: false,
//     },
//     SSSID: {
//       have: false,
//     },
//     GSISID: {
//       have: false,
//     },
//   },
//   comakerIDProof: {
//     UMID: {
//       have: true,
//       number: "",
//       front: {},
//       back: {},
//     },
//     driverLicense: {
//       have: false,
//     },
//     passport: {
//       have: false,
//     },
//     nationalID: {
//       have: false,
//     },
//     votersID: {
//       have: false,
//     },
//     SSSID: {
//       have: false,
//     },
//     GSISID: {
//       have: false,
//     },
//   },
//   residentialProof: [],
//   incomeProof: [],
//   comakerIncomeProof: [],
//   reference1: {
//   firstName: "Ubi",
//   telephoneNum: "0213481022"
// },
//   reference2: {},
//   reference3: {},
//   referenceVerified: false,
//   CSR: 1,
//   residentialPayments: "",
//   utilitiesPayments: "",
//   materials: "",
//   painted: "",
//   numberOfBedrooms: "",
//   estimatedValue: "",
//   furnitureAppliances: ['TV', 'Sala Set'],
//   neighborhoodType: "",
//   livingCondition: ['Untidy'],
//   residenceAccessibleBy: [],
//   residentialLocationImages: {
//     image1: {},
//     image2: {},
//     image3: {},
//   },
//   investigationRemarks: "INVESTIGATION REMARK",
//   salesInvestigatorName: ""
// };
